import type {ExpressionPath, ExpressionPathPart} from '@packages/systems/wfdl';

/**
 * Root path for client-only element data that is NOT persisted to the database.
 * Temp data is stripped on save/export (see stripTempData in xscpUtils,
 * ExportElementUtils). ref: Atom.ts#uiStateOnSelected —
 * "Data stored in `temp` is client only and is not persisted."
 *
 * FYI: Changes to temp data DO generate multiplayer diffs and WILL sync to
 * other designer sessions by default. If you're adding a new temp sub-key and
 * don't want it propagated to other users, you must add the full path to
 * IGNORABLE_TEMP_PATHS in removeUIOnlyExpressionDiffs.ts and export it from
 * this package so the ignore list stays in sync.
 */
type RecordPathPart = Extract<ExpressionPathPart, {in: 'Record'}>;
export const TEMP_PATH_PART: RecordPathPart = {in: 'Record', at: 'temp'};
export const TEMP_PATH: ExpressionPath = [TEMP_PATH_PART];

export type TempExpressionPath = [typeof TEMP_PATH_PART, ...RecordPathPart[]];

/**
 * Path for element UI state written by the Atom `uiStateOnSelected` API
 * (see handleNodeClicked.ts and Atom.ts#uiStateOnSelected).
 *
 * Session-local — does not sync to other designer sessions because it is in
 * IGNORABLE_TEMP_PATHS (see removeUIOnlyExpressionDiffs.ts).
 */
export const TEMP_STATE_PATH: TempExpressionPath = [
  TEMP_PATH_PART,
  {in: 'Record', at: 'state'},
];
